import { useEffect, useState } from 'react';

type TabsData = {
  rows: string[];
};

type TabsTypeProps = {
  numTabs?: number;
  onChange?: (data: TabsData) => void;
  initialData?: TabsData;
  errors?: { [key: string]: string };
};

const TabsDataType: React.FC<TabsTypeProps> = ({
  numTabs = 1,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange = () => {},
  initialData,
  errors = {},
}) => {
  const [rows, setRows] = useState<string[]>(() => {
    if (initialData?.rows && initialData.rows?.length > 0) {
      return initialData.rows;
    }

    return Array(numTabs).fill('');
  });

  // Notify parent component of all changes
  const notifyParent = () => {
    onChange({
      rows,
    });
  };

  // Handle row count changes
  useEffect(() => {
    if (rows?.length !== numTabs) {
      if (rows?.length < numTabs) {
        const newRows = Array(numTabs - rows?.length).fill('');
        setRows((prevRows) => [...prevRows, ...newRows]);
      } else {
        setRows((prevRows) => prevRows.slice(0, numTabs));
      }
    }
  }, [numTabs]);

  useEffect(() => {
    notifyParent();
  }, [rows]);

  const handleRowNameChange = (index: number, value: string) => {
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      updatedRows[index] = value;
      return updatedRows;
    });
  };

  return (
    <div className=" h-full ml-4">
      <div className=" h-90vh">
        <div className="rounded">
          <div>
            <h1 className="text-sm text-ds-gray-500 font-semibold">Tabs Configuration</h1>
            <p className="text-sm text-ds-gray-300 mt-2">
              This will display detailed information shown in the information container.
            </p>
          </div>
          <div className="pr-4 overflow-y-auto mt-4">
            {rows.map((row, index) => (
              <div key={index} className="mb-4">
                <label className="block text-sm font-medium text-gray-500 mb-1">
                  Tab {index + 1} <span className="text-ds-red-400">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Please enter tabs name"
                  className={`w-full p-3 border-2 rounded-md outline-none text-sm text-ds-gray-500 placeholder:text-ds-gray-300 ${
                    errors[`tab_${index}`] ? 'border-ds-red-400' : 'border-ds-gray-100'
                  }`}
                  value={row}
                  onChange={(e) => handleRowNameChange(index, e.target.value)}
                />
                {errors[`tab_${index}`] && (
                  <p className="text-ds-red-400 text-xs mt-1">{errors[`tab_${index}`]}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TabsDataType;
